// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HKnv","toggle":"styles_toggle__1BxL3","preview":"styles_preview__3_PRr"};